export const interviewStatuses = {
  SCHEDULED: 0,
  CANCELED: -1,
  EXECUTED: 3,
};
